import React, { useState } from "react";
import "./PromptListEditor.css";

const MAX_PROMPTS = 1000;

export default function PromptListEditor({
  prompts, onChange, placeholder, noun = "prompts", max = MAX_PROMPTS,
}) {
  const [bulkText, setBulkText] = useState("");

  const addFromBulk = () => {
    const existing = new Set(prompts.map((p) => p.trim()));
    const lines = bulkText
      .split("\n")
      .map((l) => l.trim())
      .filter((l) => l && !existing.has(l));
    const next = [...prompts, ...lines].slice(0, max);
    onChange(next);
    setBulkText("");
  };

  const updatePrompt = (i, text) => {
    const next = [...prompts];
    next[i] = text;
    onChange(next);
  };

  const removePrompt = (i) => onChange(prompts.filter((_, idx) => idx !== i));

  return (
    <div className="prompt-list-editor">
      <div className="prompt-bulk">
        <textarea
          value={bulkText}
          onChange={(e) => setBulkText(e.target.value)}
          placeholder={placeholder ?? "Paste prompts, one per line.\nExample:\nWhere can I buy running shoes?\nWho are the best local florists?"}
          rows={4}
        />
        <button type="button" className="prompt-import-btn" onClick={addFromBulk}
                disabled={!bulkText.trim() || prompts.length >= max}>
          Import
        </button>
      </div>

      <div className="prompt-counter">{prompts.length}/{max} {noun}</div>

      <ul className="prompt-list">
        {prompts.map((text, i) => (
          <li key={i} className="prompt-row">
            <input
              type="text" value={text}
              onChange={(e) => updatePrompt(i, e.target.value)}
            />
            <button type="button" className="prompt-remove-btn"
                    onClick={() => removePrompt(i)} aria-label="Remove">
              ×
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
